import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionItem, AccordionHeader, AccordionDetail } from '@vds/accordions';
import { Line } from '@vds/lines';
import { Body, Title } from '@vds/typography';

import { isMoversFlow, isWHWPhase2Flag, renderHTML } from '../../../common/Helpers';
import { isMobile } from '../../../common/Helpers/useragent';
import { Margin } from '../../../common/styles';
import { AccordionWrapper, FirstColumn, SecondColumn, StlyedMargin, StyledSurcharge, StyledTaxes, Subtext, VisuallyHidden } from './NBSView.styles';
import {
  FwaSetupIndicator,
  convertBillDates,
  convertDates,
  formatCurrency,
  formatMtnWithDecimals,
  getExtenderQuantity,
  whwNBSFlag,
} from '../NextBillsUtils';
import {WHWChargesDisclaimer} from './WHWChargesDisclaimer';


const renderLines = (mtnLevelChargeDetails, props, dbrFlag) =>
  mtnLevelChargeDetails.map((chargesItem) => {
    const {
      nickname,
      mtn,
      pendingActivationIndicator,
      npanxx,
      lineLevelTotal: { nextMonthCharge, newMonthCharge },
      lineLevelMonthlyChargesVo,
      lineLevelOneTimeChargesVo,
      lineLevelOneTimeOthVenChargesVo = [],
      lineLevelAddOnsChargesVo,
      lineLevelAddOnsOthVenChargesVo = [],
      lineLevelTotal,
      newMonthSurcharges,
      nextMonthSurcharges,
      nextMonthTax,
      newMonthTax,
      additionalInfo = [],
    } = chargesItem;
    const mtnLevelOneTimeChargesTotals = lineLevelTotal && lineLevelTotal.mtnLevelOneTimeChargesTotals;
    const mtnLevelMonthlyChargesTotals = lineLevelTotal && lineLevelTotal.mtnLevelMonthlyChargesTotals;
    const mtnLevelAddOnsChargesTotals = lineLevelTotal && lineLevelTotal.mtnLevelAddOnsChargesTotals;
    const emptyTotals = {
      nextMonthCharge: '',
      newMonthCharge: '',
    };
    return (
      <AccordionWrapper>
        <Accordion inverted={false} topLine={false} bottomLine={false}>
          <AccordionItem opened={false}>
            <AccordionHeader ariaLabel={`${nickname} ${mtn} Next bill ${nextMonthCharge} New monthly ${newMonthCharge}`}>
              {renderLineHeader(nickname, mtn, nextMonthCharge, newMonthCharge, pendingActivationIndicator, npanxx, additionalInfo)}
            </AccordionHeader>
            <AccordionDetail>
              {renderOneTimeChargesLine(
                lineLevelOneTimeChargesVo,
                mtnLevelOneTimeChargesTotals || emptyTotals,
                lineLevelOneTimeOthVenChargesVo,
                additionalInfo,
                dbrFlag,
              )}
            </AccordionDetail>
            <AccordionDetail>
            {renderMonthlyChargesLine(lineLevelMonthlyChargesVo, mtnLevelMonthlyChargesTotals || emptyTotals, additionalInfo,  dbrFlag)}
            </AccordionDetail>
            <AccordionDetail>
              <>{renderAddOnsChargesLine(lineLevelAddOnsChargesVo, mtnLevelAddOnsChargesTotals || emptyTotals, lineLevelAddOnsOthVenChargesVo)}</>
            </AccordionDetail>
            <AccordionDetail>
              <>{renderSurcharge(newMonthSurcharges, nextMonthSurcharges, props) || emptyTotals}</>
            </AccordionDetail>
            <AccordionDetail>
              <>{renderTaxes(nextMonthTax, newMonthTax, props) || emptyTotals}</>
            </AccordionDetail>
          </AccordionItem>
        </Accordion>
      </AccordionWrapper>
    );
  });

const renderAccountLevelLines = (accountLevelChargesVo) => {
  const {
    mtn,
    accountLevelTotalVO,
    accountLevelOneTimeChargesVo,
    accountLevelMonthlyChargesVo,
    accountLevelAddOnsChargesVo,
    nextMonthAcctLevelSurcharges = 0,
    newMonthAcctLevelSurcharges = 0,
    nextMonthAccountLevelTax = 0,
    newMonthAccountLevelTax = 0,
  } = accountLevelChargesVo || {};
  const emptyTotals = {
    nextMonthCharge: '',
    newMonthCharge: '',
  };
  const { nextMonthCharge, newMonthCharge } = accountLevelTotalVO || {
    nextMonthCharge: '',
    newMonthCharge: '',
  };

  const accountOneTimeVendorCharges = (accountLevelOneTimeChargesVo && accountLevelOneTimeChargesVo?.accountLevelOtherVendorCharges) || [];
  const accountAddOnVendorCharges = (accountLevelAddOnsChargesVo && accountLevelAddOnsChargesVo?.accountLevelOtherVendorCharges) || [];

  return (
    <>
      <AccordionWrapper>
        {accountLevelMonthlyChargesVo && accountLevelMonthlyChargesVo.accountLevelCharges !== undefined && (
          <Accordion inverted={false} topLine={false} bottomLine={false}>
            <AccordionItem opened={false}>
              <AccordionHeader>{renderLineHeader('Account charges', mtn, nextMonthCharge, newMonthCharge, '')}</AccordionHeader>
              <AccordionDetail>
                {accountLevelOneTimeChargesVo &&
                  renderOneTimeChargesLine(
                    accountLevelOneTimeChargesVo.accountLevelCharges,
                    accountLevelOneTimeChargesVo.accountLevelTotal || emptyTotals,
                    accountOneTimeVendorCharges,
                  )}
              </AccordionDetail>
              <AccordionDetail>
                {accountLevelMonthlyChargesVo &&
                  accountLevelMonthlyChargesVo.accountLevelCharges &&
                  accountLevelMonthlyChargesVo.accountLevelTotal &&
                  renderMonthlyChargesLine(
                    accountLevelMonthlyChargesVo.accountLevelCharges,
                    accountLevelMonthlyChargesVo.accountLevelTotal || emptyTotals,
                  )}
              </AccordionDetail>
              <AccordionDetail>
                <>
                  {accountLevelAddOnsChargesVo &&
                    renderAddOnsChargesLine(
                      accountLevelAddOnsChargesVo.accountLevelCharges,
                      accountLevelAddOnsChargesVo.accountLevelTotal,
                      accountAddOnVendorCharges,
                    )}
                </>
              </AccordionDetail>
              <AccordionDetail>
                <>{renderAccountLevelSurcharges(nextMonthAcctLevelSurcharges, newMonthAcctLevelSurcharges)}</>
              </AccordionDetail>
              <AccordionDetail>
                <>{renderAccountLevelTaxes(nextMonthAccountLevelTax, newMonthAccountLevelTax)}</>
              </AccordionDetail>
            </AccordionItem>
          </Accordion>
        )}
      </AccordionWrapper>
    </>
  );
};

const renderLineHeader = (nickname, mtn, nextMonthCharge, newMonthCharge, pendingActivationIndicator, npanxx, additionalInfo) => (
  <div style={{ display: 'flex' }}>
    <FirstColumn>
      {nickname && nickname === 'Account charges' ? (
        <div style={{ paddingBottom: '18px', paddingRight: '10px' }}>
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} bold>
            <span data-cs-mask>{nickname}</span>
          </Body>
        </div>
      ) : (
        <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} bold>
          <span data-cs-mask>{nickname}</span>
        </Body>
      )}
      <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p">
        <span data-cs-mask>{renderMTN(pendingActivationIndicator, mtn, npanxx)}</span>
      </Body>
      {pendingActivationIndicator && pendingActivationIndicator === 'Y' && (
        <Margin bottom="15px">
          <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p">
            Pending order
          </Body>
        </Margin>
      )}
      {additionalInfo && additionalInfo?.length > 0 && additionalInfo[0]?.additionalInfoType && (
        <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p">
          <span> (Second Number) </span>
        </Body>
      )}
    </FirstColumn>
    <SecondColumn>
      <div style={{ display: 'flex' }}>
        <div style={{ width: isMobile() ? '45%' : '55%', marginLeft: isMobile() ? '15px' : '10px' }}>
          <VisuallyHidden>Next Bill</VisuallyHidden>
          <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p" bold>
            {formatCurrency(nextMonthCharge)}
          </Body>
        </div>
        <div style={{ width: '45%' }}>
          <VisuallyHidden>new monthly</VisuallyHidden>
          <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p" bold>
            {formatCurrency(newMonthCharge)}
          </Body>
        </div>
      </div>
    </SecondColumn>
  </div>
);

const renderOneTimeChargesLine = (lineLevelOneTimeChargesVo, { nextMonthCharge }, lineLevelOneTimeOthVenChargesVo, additionalInfo, dbrFlag) => (
  <AccordionWrapper>
    {lineLevelOneTimeChargesVo && (
      <Accordion inverted={false} topLine={false} bottomLine={false}>
        <AccordionItem opened={false}>
          <AccordionHeader>{renderSubLineHeader('One-time charges', 'and credits', nextMonthCharge, 0)}</AccordionHeader>
          <AccordionDetail data-testid="subLineTestId">
            {lineLevelOneTimeChargesVo.map((oneTimeCharges) => renderSubLine(oneTimeCharges, false, false, additionalInfo, dbrFlag, {}))}
          </AccordionDetail>
          <AccordionDetail>
            {lineLevelOneTimeOthVenChargesVo && lineLevelOneTimeOthVenChargesVo?.length > 0 && (
              <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} style={{ marginTop: '12px' }} bold>
                Purchases from other
                {isMobile() ? <br /> : ' '}
                vendors
              </Body>
            )}
            {lineLevelOneTimeOthVenChargesVo?.map((oneTimeCharges) => renderSubLine(oneTimeCharges, true, false, additionalInfo, dbrFlag, {}))}
          </AccordionDetail>
        </AccordionItem>
      </Accordion>
    )}
  </AccordionWrapper>
);

const renderMonthlyChargesLine = (lineLevelMonthlyChargesVo, { nextMonthCharge, newMonthCharge }, additionalInfo, dbrFlag) => (
  <AccordionWrapper>
    {(lineLevelMonthlyChargesVo || lineLevelMonthlyChargesVo.length) && (
      <Accordion inverted={false} topLine={false} bottomLine={false}>
        <AccordionItem opened={false}>
          <AccordionHeader>{renderSubLineHeader('Monthly charges', 'and credits', nextMonthCharge, newMonthCharge)}</AccordionHeader>
          <AccordionDetail>
            {lineLevelMonthlyChargesVo.map((monthlyCharges) => renderSubLine(monthlyCharges, true, true, additionalInfo, dbrFlag))}
          </AccordionDetail>
        </AccordionItem>
      </Accordion>
    )}
  </AccordionWrapper>
);

const renderAccountLevelSurcharges = (nextMonthAcctLevelSurcharges, newMonthAcctLevelSurcharges) => (
  <StyledSurcharge>{renderSubLineHeader('Surcharges', false, nextMonthAcctLevelSurcharges, newMonthAcctLevelSurcharges)}</StyledSurcharge>
);

const renderAccountLevelTaxes = (nextMonthAccountLevelTax, newMonthAccountLevelTax) => (
  <StyledTaxes>{renderSubLineHeader('Taxes & Govt. Fees', false, nextMonthAccountLevelTax, newMonthAccountLevelTax)}</StyledTaxes>
);

const renderAddOnsChargesLine = (lineLevelAddOnsChargesVo, { nextMonthCharge, newMonthCharge }, lineLevelAddOnsOthVenChargesVo) => (
  <AccordionWrapper>
    {lineLevelAddOnsChargesVo && lineLevelAddOnsChargesVo.length > 0 && (
      <Accordion inverted={false} topLine={false} bottomLine={false}>
        <AccordionItem opened={false}>
          <AccordionHeader>{renderSubLineHeader('Services & Perks', false, nextMonthCharge, newMonthCharge)}</AccordionHeader>
          <AccordionDetail>{lineLevelAddOnsChargesVo.map((addOnsCharge) => renderSubLine(addOnsCharge, true, false, {}, '', {}))}</AccordionDetail>
          <AccordionDetail>
            {lineLevelAddOnsOthVenChargesVo && lineLevelAddOnsOthVenChargesVo?.length > 0 && (
              <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} style={{ marginTop: '12px' }} bold>
                Purchases from
                {isMobile() ? <br /> : ' '}
                other vendors
              </Body>
            )}
            {lineLevelAddOnsOthVenChargesVo?.map((addOnsCharge) => renderSubLine(addOnsCharge, true, false, {}, '', {}))}
          </AccordionDetail>
        </AccordionItem>
      </Accordion>
    )}
  </AccordionWrapper>
);

const renderSurcharge = (newMonthSurcharges, nextMonthSurcharges, props) => (
  <StyledSurcharge>{renderSubLineHeader(props.surchargesLabel || 'Surcharges', false, nextMonthSurcharges, newMonthSurcharges)}</StyledSurcharge>
);

const renderTaxes = (nextMonthTax, newMonthTax, props) => (
  <StyledTaxes>{renderSubLineHeader(props.taxLabel || 'Taxes & Govt. Fees', false, nextMonthTax, newMonthTax)}</StyledTaxes>
);

const renderSubLineHeader = (title, title2, nextMonthCharge, newMonthCharge) => (
  <div style={{ display: 'flex' }}>
    <FirstColumn>
      <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} bold>
        {title}
        {isMobile() ? <br /> : ' '}
        {title2}
      </Body>
    </FirstColumn>
    <SecondColumn>
      <div style={{ display: 'flex' }}>
        <div style={{ width: isMobile() ? '45%' : '55%', marginLeft: isMobile() ? '15px' : '10px' }}>
          <VisuallyHidden>Next Bill</VisuallyHidden>
          <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p" bold>
            {title !== 'Surcharges' && title !== 'Taxes & Govt. Fees' && formatCurrency(nextMonthCharge)}
            {(title === 'Surcharges' || title === 'Taxes & Govt. Fees') && formatCurrency(nextMonthCharge)}
          </Body>
        </div>
        <div style={{ width: '45%', marginLeft: isMobile() ? '0px' : '25px' }}>
          <VisuallyHidden>new monthly</VisuallyHidden>
          <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p" bold>
            {title !== 'Surcharges' && title !== 'Taxes & Govt. Fees' && formatCurrency(newMonthCharge)}
            {(title === 'Surcharges' || title === 'Taxes & Govt. Fees') && formatCurrency(newMonthCharge)}
          </Body>
        </div>
      </div>
    </SecondColumn>
  </div>
);

const renderSubLine = (charges, showNextMonthPrice, showApoDiscount, additionalInfo, dbrFlag, props) => {
  const {
    hasNextMonthPromoDiscount,
    hasThisMonthPromoDiscount,
    nextMonthCharge,
    thisMonthCharge,
    description,
    chargeEffectiveDate,
    chargeEndDate,
    fwaMessageType,
    itemType,
    expiryDate,
    promo1EndDate,
    promo2EndDate,
    promo3EndDate,
    spoCategoryCodeList,
  } = charges;
  const displayDesc = description?.split('|');
  const { isPROMO, isEQUIPMENT, isPLAN = false, isNAF = false, isPerk = false, isSPO = false } = itemType;
  const isAPODiscount = (isPLAN || isNAF) && charges?.apoIndicator === 'Y' && showApoDiscount;

  let displayDetails = null;
  if (isEQUIPMENT) {
    const { loanNumber, nextInstallmentNumber, totalInstallmentNumber, outstandingLoanAmount, loanAmount } = charges || {};
    const remainingLabel = props?.remainingLabel || 'remaining';

    displayDetails =
      loanNumber && nextInstallmentNumber && totalInstallmentNumber && outstandingLoanAmount && loanAmount > 0
        ? `(${nextInstallmentNumber} of ${totalInstallmentNumber}, $${outstandingLoanAmount} ${remainingLabel})`
        : '';
  }

  return (
    <div style={{ display: 'flex', marginTop: '12px' }}>
      <FirstColumn>
        {displayDesc && displayDesc.length && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'}>
            {renderHTML(displayDesc[0])} <br />
            <Subtext>{renderHTML(displayDesc[1])}</Subtext>
            {isWHWPhase2Flag() && whwNBSFlag(spoCategoryCodeList) && isSPO && <Subtext>{`${getExtenderQuantity(spoCategoryCodeList)}`}</Subtext>}            
          </Body>
        )}
        {displayDetails && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} color="#747676">
            {displayDetails}
          </Body>
        )}
        {isAPODiscount && (
          <Body viewport="desktop" primitive="p" style={{ width: '80%', paddingTop: '10px' }} size={isMobile() ? 'medium' : 'large'}>
            {charges?.apoDescription}
            {isMobile() ? ' ' : <br />}
            {charges?.apoDescription2}
          </Body>
        )}
        {isPerk && !isPROMO && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} color="#747676">
            Plan perk
          </Body>
        )}
        {isPLAN && additionalInfo && additionalInfo?.length > 0 && additionalInfo[0]?.additionalInfoType && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} color="#747676">
            <span>{`Shared with device (${additionalInfo[0]?.additionalInfoValue})`}</span>
          </Body>
        )}
        {chargeEffectiveDate && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} color="#747676">
            {`(${convertDates(chargeEffectiveDate)}`}
            {' - '}
            {`${convertDates(chargeEndDate)})`}
            <WHWChargesDisclaimer spoCategoryCodeList={spoCategoryCodeList} isSPO={isSPO}/>
          </Body>
        )}
        {expiryDate && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} color="#747676">
            {`(Expires ${convertDates(expiryDate)}, ${new Date(expiryDate).getFullYear()})`}
          </Body>
        )}
        {isPROMO && promo1EndDate && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} color="#747676">
            {Number(promo1EndDate)
              ? `${promo1EndDate} months on us`
              : `(Expires ${convertDates(promo1EndDate)}, ${new Date(promo1EndDate).getFullYear()})`}
          </Body>
        )}
        {isPROMO && promo2EndDate && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} color="#747676">
            {Number(promo2EndDate)
              ? `${promo2EndDate} months on us`
              : `(Expires ${convertDates(promo2EndDate)}, ${new Date(promo2EndDate).getFullYear()})`}
          </Body>
        )}
        {isPROMO && promo3EndDate && (
          <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'} color="#747676">
            {Number(promo3EndDate)
              ? `${promo3EndDate} months on us`
              : `(Expires ${convertDates(promo3EndDate)}, ${new Date(promo3EndDate).getFullYear()})`}
          </Body>
        )}
        {fwaMessageType && (
          <span data-cs-mask style={{ marginTop: '10px' }}>
            {FwaSetupIndicator(fwaMessageType, dbrFlag)}
          </span>
        )}
      </FirstColumn>
      <SecondColumn>
        <div style={{ display: 'flex', marginLeft: isMobile() ? '0px' : '10px' }}>
          <div style={{ width: isMobile() ? '45%' : '55%', marginLeft: isMobile() ? '15px' : '0px' }}>
            <VisuallyHidden>Next Bill</VisuallyHidden>
            {isAPODiscount && (
              <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'}>
                <span style={nextMonthCharge > 0 ? { textDecoration: 'line-through' } : { textDecoration: null }}>
                  {nextMonthCharge > 0 ? formatCurrency(charges?.nextMonthUndiscCharge) : '$0.00'}
                </span>
                {nextMonthCharge > 0 ? (
                  <div style={isMobile() && displayDesc.length > 19 ? { marginTop: '1rem' } : { marginTop: null }}>
                    {formatCurrency(nextMonthCharge)}
                  </div>
                ) : (
                  ''
                )}
              </Body>
            )}
            {!isAPODiscount &&
              (isPROMO && !hasNextMonthPromoDiscount ? (
                <span>-</span>
              ) : (
                <>
                  <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'}>
                    {formatCurrency(nextMonthCharge)}
                  </Body>
                </>
              ))}
          </div>
          <div style={{ width: '45%', marginLeft: isMobile() ? '0px' : '25px' }}>
            <VisuallyHidden>new monthly</VisuallyHidden>
            <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'}>
              {isAPODiscount && (
                <Body viewport="desktop" primitive="p" size={isMobile() ? 'medium' : 'large'}>
                  <span style={charges?.thisMonthUndiscCharge > 0 ? { textDecoration: 'line-through' } : { textDecoration: null }}>
                    {formatCurrency(charges?.thisMonthUndiscCharge)}
                  </span>
                  <div style={isMobile() && displayDesc.length > 19 ? { marginTop: '1rem' } : { marginTop: null }}>
                    {formatCurrency(thisMonthCharge)}{' '}
                  </div>
                </Body>
              )}
              {!isAPODiscount &&
                (!showNextMonthPrice || (isPROMO && !hasThisMonthPromoDiscount) ? formatCurrency(0) : formatCurrency(thisMonthCharge))}
            </Body>
          </div>
        </div>
      </SecondColumn>
    </div>
  );
};

const renderMTN = (pendingActivationIndicator, mtn, npanxx) => {
  let mtnValue = '';

  if (pendingActivationIndicator && pendingActivationIndicator === 'Y') {
    mtnValue = npanxx && npanxx !== '' && npanxx !== 'undefined' ? `${formatMtnWithDecimals(npanxx)}(new)` : '';
    if (isMoversFlow() && mtn) {
      mtnValue = formatMtnWithDecimals(mtn);
    }
  } else {
    mtnValue = formatMtnWithDecimals(mtn);
  }

  return mtnValue;
};

const NBSView = (props) => {
  const nbsVo = props.data || {};
  const dbrFlag = props.dbrFlag || false;
  const mtnLevelChargeDetails = nbsVo && nbsVo.lineLevelChargesVo && nbsVo.lineLevelChargesVo.mtnLevelChargeDetails;
  const currDate = nbsVo && nbsVo?.currentFormattedDate;
  const typeOfTransaction =
    nbsVo && nbsVo.nbsIndicators && nbsVo.nbsIndicators.oneMessageTransactionType && nbsVo.nbsIndicators.typeOfTransaction.trim().toUpperCase();
  const nextMonthDateRange = nbsVo && nbsVo?.monthlyTotalsInfo && nbsVo?.monthlyTotalsInfo?.nextMonthChargeDateRange;

  return (
    <div id="nbs" data-testid="NBSViewComponent">
      <Margin top="20px" bottom="5px">
        <Title size="medium" primitive="h3" bold>
          Estimated charges as of {currDate}
        </Title>
      </Margin>
      {typeOfTransaction === 'Y' && (
        <Margin bottom="20px">
          <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
            Your first bill cycle will begin once you activate a device. The dates shown below are based on the expected delivery date.
          </Body>
        </Margin>
      )}
      <StlyedMargin top="12px">
        <div style={{ display: 'flex' }}>
          <FirstColumn>&nbsp;</FirstColumn>
          <SecondColumn>
            <div style={{ display: 'flex' }}>
              <div style={{ width: isMobile() ? '45%' : '55%', marginLeft: isMobile() ? '15px' : '0px', paddingBottom: '1rem' }}>
                <Body size="large" primitive="p" bold>
                  {typeOfTransaction === 'Y' || typeOfTransaction === 'C' ? 'First bill' : 'Next bill'}
                </Body>
                <Body size="large" primitive="p">
                  {convertBillDates(nextMonthDateRange)}
                </Body>
              </div>
              <div style={{ width: '45%', whiteSpace: 'nowrap' }}>
                <Body size="large" primitive="p" bold>
                  {typeOfTransaction === 'Y' || typeOfTransaction === 'C' ? 'Monthly bill' : 'New monthly'}
                </Body>
              </div>
            </div>
          </SecondColumn>
        </div>
      </StlyedMargin>
      <div>{renderAccountLevelLines(nbsVo && nbsVo.accountLevelChargesVo)}</div>
      {mtnLevelChargeDetails && mtnLevelChargeDetails.length > 0 && <div>{renderLines(mtnLevelChargeDetails, props, dbrFlag)}</div>}

      <Margin top="20px" bottom="10px">
        <Line type="primary" style={{ marginBottom: '20px' }} />
        <div style={{ display: 'flex' }}>
          <FirstColumn>
            <Body primitive="p" size="large" bold>
              Your estimated bill
            </Body>
          </FirstColumn>
          <SecondColumn>
            <div style={{ display: 'flex' }}>
              <div style={{ width: isMobile() ? '45%' : '55%', marginLeft: isMobile() ? '15px' : '0px' }}>
                <VisuallyHidden>{typeOfTransaction === 'Y' || typeOfTransaction === 'C' ? 'First bill' : 'Next bill'}</VisuallyHidden>
                <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p" bold>
                  {nbsVo.monthlyTotalsInfo && formatCurrency(nbsVo.monthlyTotalsInfo.nextMonthCharge)}
                </Body>
              </div>
              <div style={{ width: '45%', marginLeft: isMobile() ? '0px' : '25px' }}>
                <VisuallyHidden>{typeOfTransaction === 'Y' || typeOfTransaction === 'C' ? 'Monthly bill' : 'New monthly'}</VisuallyHidden>
                <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p" bold>
                  {nbsVo.monthlyTotalsInfo && formatCurrency(nbsVo.monthlyTotalsInfo.newMonthCharge)}
                </Body>
              </div>
            </div>
          </SecondColumn>
        </div>
      </Margin>
      <div>
        {typeOfTransaction !== 'Y' && typeOfTransaction !== 'C' ? (
          <Body size="large" primitive="p">
            {props.taxesAndFeesNote}
            <br />
            {props.taxesAndFeesNote2}
          </Body>
        ) : (
          <>
            <Body size="large" primitive="p">
              {props.taxesAndFeesNoteNSE1}
              <br />
              {props.taxesAndFeesNoteNSE2}
            </Body>
          </>
        )}
      </div>
    </div>
  );
};

NBSView.defaultProps = {
  taxesAndFeesNote: 'Taxes, fees and surcharges are estimated ',
  taxesAndFeesNote2: 'and will be itemized in your next bill.',
  taxesAndFeesNoteNSE1: 'Taxes, fees and surcharges are estimated ',
  taxesAndFeesNoteNSE2: 'and will be itemized once your bill is ready.',
};

NBSView.propTypes = {
  data: PropTypes.object,
  taxesAndFeesNote: PropTypes.string,
  taxesAndFeesNote2: PropTypes.string,
  taxesAndFeesNoteNSE1: PropTypes.string,
  taxesAndFeesNoteNSE2: PropTypes.string,
  dbrFlag: PropTypes.bool,
};

export default React.memo(NBSView);
